import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const list = [
	{ name: 'Getting Started', link: '' },
	{ name: 'Server Authentication', link: 'server-authentication' },
	{ name: 'Client Authentication', link: 'client-authentication' },
	{ name: 'Common Objects', link: 'common-objects' },
	{ name: 'Making A Request', link: 'making-a-request' },
	{ name: 'Rate Limiting', link: 'rate-limiting' },
	{ name: 'Simple Tasks', link: 'simple-tasks' },
	{ name: 'Post Routing', link: 'post-routing' },
	{ name: 'JSON Data Types', link: 'json-data-types' },
	{ name: 'Image Formats', link: 'image-formats' },
	{ name: 'Batch Requests', link: 'batch-requests' },
	{ name: 'Continuable List Responses', link: 'continuable-list' },
	{ name: 'CORS', link: 'cors' }

];
class SidebarDropdown extends React.Component {
	constructor(props) {
		super(props);
		this.select = this.select.bind(this);
	}

	select(event) {
		this.props.dispatch(push('/getting-started/' + event.target.value));
	}

	render() {
		const ItemLinks = list.map((item, index) =>
			<option key={index} name={item.name} value={item.link}>{item.name}</option>
		);
		return (
			<div className='dropdown-container'>
				<select className='dropdown-list' onChange={this.select}>
					{ItemLinks}
				</select>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const { match } = ownProps;

	if (match) {
		const pathLink = match.path;

		return {
			selectedName: pathLink
		};
	}

	return {};
};

SidebarDropdown.propTypes = {
	dispatch: PropTypes.func.isRequired
};


export default withRouter(connect(mapStateToProps)(SidebarDropdown));


// WEBPACK FOOTER //
// ./src/components/getting-started/SidebarDropdown.js